// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrap":"Alert_buttonsWrap__2ln9d","buttonsVerticalWrap":"Alert_buttonsVerticalWrap__a_LB4"};